<template>
  <div>
    <table-card
      :items="partners"
      :fields="fields"
      title="Demand Partners">

      <template slot="id" slot-scope="data">
        <b-badge>{{ data.value }}</b-badge>
      </template>
      <template v-slot:cell(settings)="data">
        <div class="hidden-button-group float-right">
          <icon-button :to="{ name: 'AdminDemandSettings', params: { cid: data.item.company_id }}" icon="icon-Settings"
                       variant="outline-border" tooltip="Settings"></icon-button>
        </div>
      </template>
    </table-card>
  </div>
</template>

<script>
    import {DemandApi} from '@/demand/api'
    import preRouteDataFetcher from '@/mixins/preRouteDataFetcher'
    import TableCard from '@/components/TableCard'

    export default {
        name: 'AdminDemandPartners',
        data() {
            return {
                partners: [],
                fields: [
                    {key: 'name', sortable: true},
                    {key: 'company_id', sortable: true},
                    {key: 'human_review'},
                    {key: 'nurl', label: 'WinUrl'},
                    {key: 'sync_url', label: 'Syncing', formatter: (s) => (s && s !== null && s !== '') || false },
                    {key: 'settings', label: 'Settings'}
                ]
            }
        },
        methods: {
            list(partners) {
                this.partners = partners
            }
        },
        mixins: [
            //mixin args handle data fetching and display
            preRouteDataFetcher(() => {
                return DemandApi.list()
            }, (data, vm) => {
                vm.list(data.list)
            })
        ],
        components: {
            TableCard
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/pages/DemandPartners.vue